import {
  FontSizes,
  NeutralColors,
  Panel,
  PanelType,
  Spinner,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";

import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import { _helperIBaseResponse } from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";

interface PanelViewPdfDocumento {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  urlDoc: string;
}

export const PanelViewPdfDocumento = (props: PanelViewPdfDocumento) => {
  const [loadind, setloading] = useState(false);

  const [archivo, setarchivo] = useState("");
  const [file, setfile] = useState("");

  useEffect(() => {
    if (props.isOpen) {
      _confirmar();
    }
  }, [props.isOpen]);

  useEffect(() => {
    decodeBase64ToPdf(archivo);
  }, [archivo]);

  function decodeBase64ToPdf(encodedString) {
    fetch(encodedString)
      .then((res) => res.blob())

      .then((blob) => {
        setfile(URL.createObjectURL(blob));

        // return new File([blob], "Filename.pdf", { type: "application/pdf" });
      });
  }

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            Visualizar Documento
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    []
  );

  const _confirmar = () => {
    if (props.urlDoc) {
      setloading(true);
      grupoDocumentoService
        .getBase64({ listUrlBase: [props.urlDoc] })
        .then((res) => {
          if (res.status === 200) {
            // console.log(res.data[0]);

            setarchivo(res.data[0]);
            setloading(false);
          }
        })
        .catch((err: Error) => {
          console.log(err);
        });
    }
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Crear"
          texto2={"Cancelar"}
          onClick={() => {}}
          onDismiss={() => {
            // _goback();
          }}
          disableButton={false}
        />
      </>
    ),
    [props.onDismiss]
  );

  const limpiarResponse = () => {
    setarchivo("");
    setloading(false);
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
  };

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      //   onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="800px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        {/* <pre>{JSON.stringify(archivo, null, 2)}</pre> */}

        {loadind && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Spinner label="Cargando..." style={{ fontSize: 20 }} />
          </div>
        )}
        {!loadind && archivo && file && (
          <iframe src={`${file}`} width="100%" height="100%" />
        )}
      </>
    </Panel>
  );
};
